import "./Testimonial.css";
import star from "../../Images/Icons/star.png";
import profile from "../../Images/ReviewImage/suman.png";
import img1 from "../../Images/ReviewImage/image1.png";
import img2 from "../../Images/ReviewImage/img2.jpg";
import img3 from "../../Images/ReviewImage/img3.jpg";
import img4 from "../../Images/ReviewImage/sonam.png";
import img5 from "../../Images/ReviewImage/rabu.png";

import Headline from "../Headline/Headline";
const reviews = [
    {
        title: "He is an exceptional designer and an outstanding content creator.",
        subtitle: " His creative work consistently inspires newcomers, and his designs have a unique way of motivating others. What truly sets him apart is his ability to magnify brands—showcasing them in the best light and bringing out their true potential. Truly one of the best in the field!",
        img: img1,
        name: "Suman Stha",
        post: "Social Media Manager"
    },
    {
        title: "Bhanubhakta Sapkota ( Thevisualdesigner ) is great designer.    ",
        subtitle: " He’s creative, professional, and good at both graphic and UI/UX design. I’d definitely recommend him.",
        img: img2,
        name: "Swastika Gautam",
        post: "Graphic Designer"
    },
    {
        title: "The Visual Designer is one of the best designers I’ve worked with. ",
        subtitle: " The creativity, attention to detail, and understanding of modern design trends are impressive. Every design feels premium, clean, and purposeful. Communication was smooth, delivery was on time, and the final output exceeded my expectations.",
        img: img3,
        name: "Bishal Dhakal",
        post: "MERN Stack Developer"
    },
    {
        title: "I had a really good experience working with him.",
        subtitle: "Very professional, reliable, and delivers exactly what is promised. I highly recommend trying his service at least once—you’ll definitely see the value.",
        img: img4,
        name: "Sanjay Adhikari",
        post: "Full Stack Developer"
    },
    {
        title: "Ekdam respectful ra talented graphic designer",
        subtitle: "Uhako creativity, clean design style ra professionalism dherai impressive cha. Recommend garna sakincha without any doubt.",
        img: img5,
        name: "Rabin Paudel",
        post: "Content Creator"
    }
]
const Testimonial = () => {
    return (
        <>
            <div className="testimonialSec">
                <div className="titleTestimonial">
                   <Headline text={"Testimonials"}/>
                </div>

                <div className="listTestimonial">
                    <div className="testimonialsBoxes">
                        {reviews.map((rev) =>
                            <div className="serviceBox testBox">
                                <div className="topService">
                                    <div className="texts">
                                        <img src={star} alt="" />
                                        <img src={star} alt="" />
                                        <img src={star} alt="" />
                                        <img src={star} alt="" />
                                        <img src={star} alt="" />
                                        <span></span>
                                        <span></span>
                                    </div>


                                    <span className="forBigService"></span>
                                    <span className="forBigService2"></span>
                                </div>
                                <div className="testimonialReview">
                                    <div className="testimonialHeadline">
                                        “{rev.title}”
                                    </div>
                                    <div className="testimonialDesc">
                                        {rev.subtitle}
                                    </div>
                                    <div className="testimonialProfile">
                                        <div className="left">
                                            <img src={rev.img} alt="" />
                                        </div>
                                        <div className="right">
                                            <div className="name">
                                                <h2>{rev.name}</h2>
                                            </div>
                                            <div className="post">
                                                {rev.post}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>


                </div>
            </div>
        </>
    )
}
export default Testimonial;